import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';

type TypeOfEntityType = 'BRAND' | 'CLIENT' | 'SUPPLIER' | 'DEAL' | 'LEAD' | 'PURCHASE_REQUEST' | 'PURCHASE_ORDER';

export const AllEntityTypes: Record<
  string,
  { label: string; value: TypeOfEntityType; path: string; disabled?: boolean; tab?: string; permission?: string }
> = {
  BRAND: {
    label: 'Brand',
    value: 'BRAND',
    path: ADMIN_ROUTES.brand.view,
    tab: ADMIN_ROUTES.brand.management,
    permission: PERMISSIONS.brands.brand.read,
  },
  CLIENT: {
    label: 'Client',
    value: 'CLIENT',
    path: ADMIN_ROUTES.client,
    tab: ADMIN_ROUTES.clientManagement,
    permission: PERMISSIONS.clients.client.read,
  },
  SUPPLIER: {
    label: 'Supplier',
    value: 'SUPPLIER',
    path: ADMIN_ROUTES.suppliers.view,
    tab: ADMIN_ROUTES.suppliers.general,
    permission: PERMISSIONS.suppliers.supplier.read,
  },
  LEAD: {
    label: 'Lead',
    value: 'LEAD',
    path: ADMIN_ROUTES.leads.view,
    tab: ADMIN_ROUTES.leads.general,
    permission: PERMISSIONS.leads.lead.read,
  },
  DEAL: {
    label: 'Deal',
    value: 'DEAL',
    path: ADMIN_ROUTES.deals.view,
    tab: ADMIN_ROUTES.deals.purchaseRequest,
    permission: PERMISSIONS.deals.deal.read,
  },
  // PURCHASE_REQUEST: {
  //   label: 'Purchase Request',
  //   value: 'PURCHASE_REQUEST',
  //   path: ADMIN_ROUTES.purchaseRequest.view,
  //   tab: ADMIN_ROUTES.purchaseRequest.general,
  //   permission: PERMISSIONS.purchaseRequests.purchaseRequest.read,
  // },
  PURCHASE_ORDER: {
    label: 'Purchase Order',
    value: 'PURCHASE_ORDER',
    path: ADMIN_ROUTES.purchaseOrder.view,
    tab: ADMIN_ROUTES.purchaseOrder.general,
    permission: PERMISSIONS.purchaseOrders.purchaseOrder.read,
  },
};

type NoteAction = {
  propertyName: string;
  from: string | null;
  to: string | null;
};

type NoteUser = {
  files?: {
    AVATAR?: string;
  };
  userName: string;
  firstName: string;
  lastName: string;
  id: string;
};

type Note = {
  attachments: any;
  note: string;
  pinned: boolean;
  relations: any;
  lastModifiedDate: string;
  createDate: string;
  id: string;
  entityId: string;
  entityName: string;
  userId: string;
  title: string;
  user: NoteUser;
  actions: NoteAction[];
};

export type { TypeOfEntityType, Note };
